import { Component, OnInit } from '@angular/core';
import { GlobalService } from '../services/global.service';
import { AuthService } from '../services/auth.service';

@Component({
  selector: 'google-login',
  templateUrl: './google-login.component.html',
  styleUrls: ['./google-login.component.scss']
})
export class GoogleLoginComponent implements OnInit {

  constructor(private auth: AuthService, private global: GlobalService) { }

  ngOnInit() {
    this.global.toggleBlockUI();
    let url = document.URL;
    let code = url.slice(url.toString().indexOf("&code=") + 6, url.toString().indexOf("&scope=")).replace("%2F","/");
    this.auth.loginWithGoogle(code).then(res=>{
      window.close();
    }).catch(error=>{
      this.global.showErrorDialog(error);
    });

  }

}
